import { attemptTokenRefresh } from 'shared/api/auth/attemptTokenRefresh'
import { CustomEvents } from 'shared/constants/customEvents'
import { LocalStorageKey } from 'shared/constants/localStorage'
import { User } from 'shared/types/user'

import { dispatchCustomEvent } from './customEvents'
import { lsSetItem } from './local-storage'

/**
 * /checkToken is the only source of truth for `twofa_checked` on reload, is
 * keyed off the current access token, and only polls every few minutes in
 * the multi-tab "leader" tab (see useIsLoggedIn) - so a plain
 * AUTH_USER_DATA_UPDATED dispatch here is invisible to it. Forcing a token
 * refresh gets a fresh, authoritative checkToken cycle immediately so the
 * toggle doesn't revert on next page load or in a non-leader tab.
 */
export const persistTwoFaChecked = (
  user: User | null | undefined,
  twofa_checked: 0 | 1,
  // Callers that immediately trigger their own re-login/re-issue (e.g. the
  // guest DeactivateTwoFa flow, which logs the user in right after) should
  // skip this: refreshing with the about-to-be-rotated refresh token races
  // that flow's own token rotation, and the follow-up login already gets a
  // fresh, correct token.
  { skipTokenRefresh = false }: { skipTokenRefresh?: boolean } = {}
) => {
  if (!user) return

  const updatedUser = { ...user, twofa_checked }
  lsSetItem(LocalStorageKey.USER, updatedUser)
  dispatchCustomEvent(CustomEvents.AUTH_USER_DATA_UPDATED, {
    user: updatedUser
  })

  if (!skipTokenRefresh) attemptTokenRefresh()
}
